import { render, staticRenderFns } from "./LoadingShim.vue?vue&type=template&id=4100ba70&scoped=true"
import script from "./LoadingShim.vue?vue&type=script&lang=ts"
export * from "./LoadingShim.vue?vue&type=script&lang=ts"
import style0 from "./LoadingShim.vue?vue&type=style&index=0&id=4100ba70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4100ba70",
  null
  
)

export default component.exports